import React from 'react';
import Marquee from 'react-fast-marquee';

export default function EditorialMarquee() {
  return (
    <div className="border-y border-border/60 py-6 md:py-8 bg-espresso overflow-hidden">
      <Marquee speed={38} gradient={false} pauseOnHover>
        {['Авторские туры', 'Настоящая Индия', 'Русский гид Али', 'Дивали 2026', 'Холи 2026', 'Новый год у Ганга', 'Золотой Треугольник', 'Кхаджурахо', 'Ришикеш'].map((t, i) => (
          <span key={i} className="inline-flex items-center mx-8 md:mx-12">
            <span className="font-serif-display italic text-3xl md:text-5xl text-foreground/90">
              {t}
            </span>
            <span className="mx-8 md:mx-12 w-2 h-2 rounded-full bg-saffron inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
